//
export class ProviderBuilder {
    providers = [];
    useClass(provide, useClass, deps, provideInRoot) {
        this.providers.push({
            provide,
            useClass,
            deps: deps,
            provideInRoot,
        });
        return this;
    }
    useFactory(provide, useFactory, deps, provideInRoot) {
        this.providers.push({
            provide,
            useFactory,
            deps: deps,
            provideInRoot,
        });
        return this;
    }
    useValue(provide, useValue, provideInRoot) {
        this.providers.push({
            provide,
            useValue,
            provideInRoot,
        });
        return this;
    }
    /** @internal */
    _getProviders() {
        return this.providers;
    }
}
//# sourceMappingURL=provider-builder.js.map